import _styled from '@emotion/styled/base';
import Box from '@mui/material/Box';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import isStyledPropsValid from '../../utils/isStyledPropsValid.js';
const StyledMenu = /*#__PURE__*/_styled(Menu, {
  shouldForwardProp: isStyledPropsValid,
  target: "e1erft1c4"
})(_ref => {
  return {
    '& .MuiPaper-root': {
      width: '300px',
      marginTop: '10px'
    },
    '& .sub-title': {
      fontSize: '12px !important',
      color: '#A5A5A5',
      opacity: 1,
      borderTop: '1px solid #F8F8F8',
      paddingTop: '16px'
    }
  };
}, "");
const StyledMenuTitle = /*#__PURE__*/_styled(Box, {
  shouldForwardProp: isStyledPropsValid,
  target: "e1erft1c3"
})(_ref2 => {
  return {
    fontWeight: '700',
    fontSize: '16px',
    color: '#555555',
    cursor: 'default'
  };
}, "");
const StyledShownArea = /*#__PURE__*/_styled(Box, {
  shouldForwardProp: isStyledPropsValid,
  target: "e1erft1c2"
})(_ref3 => {
  return {
    marginBottom: '16px'
  };
}, "");
const StyledMenuItem = /*#__PURE__*/_styled(MenuItem, {
  shouldForwardProp: isStyledPropsValid,
  target: "e1erft1c1"
})(_ref4 => {
  let {
    theme,
    isFixed
  } = _ref4;
  return {
    display: 'flex',
    alignItems: 'center',
    cursor: 'default',
    '&:hover': {
      backgroundColor: '#F7F1FE'
    },
    '& .list-item-btn': {
      marginLeft: 'auto',
      opacity: 1,
      '& i': {
        color: isFixed ? '#E6E6E6' : '#383538',
        fontWeight: '400'
      }
    }
  };
}, "");
const StyledDragHandlerBarArea = /*#__PURE__*/_styled(Box, {
  shouldForwardProp: isStyledPropsValid,
  target: "e1erft1c0"
})(_ref5 => {
  return {
    width: '20px',
    height: '20px',
    marginRight: '10px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    color: '#A5A5A5'
  };
}, "");
export { StyledDragHandlerBarArea, StyledMenu, StyledMenuItem, StyledMenuTitle, StyledShownArea };